const capitalize = (string, forceLowercase = false) => {
    return typeof string === 'string'
        ? string.slice(0, 1).toUpperCase() + (forceLowercase
            ? string.slice(1).toLowerCase()
            : string.slice(1))
        : string
}

module.exports = capitalize